var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementGreenBlueCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.82 252.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a900a470-0174-44c5-ba31-58ce86c55129{opacity:0.5;}.fc34020f-110d-4f3e-86b4-f8f2fa7724a0{fill:#33aac6;}.efac782b-7e25-4137-966c-14c7964c6f43{opacity:0.6;}.e0e0f5e5-3f0d-4615-af0c-8db9f35709df{fill:#0fc571;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ae486ca4-9198-4e61-9d55-3bc34e22870a",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f0a4f68f-3fbc-4a6e-8341-7e31b5f7b638",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b59d62ba-0d33-49c7-851c-5cb48ca33fb9",
    "data-name": "Shape 3 copy",
    className: "a900a470-0174-44c5-ba31-58ce86c55129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee11d4da-45e3-40a9-9ea4-3712cc2534c3",
    "data-name": "Shape 3 copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fc34020f-110d-4f3e-86b4-f8f2fa7724a0",
    d: "M264.7,0H0C84.32,30.28,174.23,126.09,174.23,126.09c56.4,51.62,91.58,41.69,91.58,41.69Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "b6c0ed40-0723-4764-bf7b-6de773a71dad",
    "data-name": "Shape 4 copy",
    className: "efac782b-7e25-4137-966c-14c7964c6f43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ea1635ce-94a2-4885-a838-6a8aa46fd0d5",
    "data-name": "Shape 4 copy-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e0e0f5e5-3f0d-4615-af0c-8db9f35709df",
    d: "M206.31,3.25s-100.07,85.36-35,191.39c0,0,35,51.67,100.51,57.51V5.05Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementGreenBlueCorner);
export default __webpack_public_path__ + "static/media/element-GreenBlueCorner.ddee0f83f2f97141f96ab3e12f6aa106.svg";
export { ForwardRef as ReactComponent };